import * as React from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/deltamax/h5/');
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IAppProps {}

const App: React.FunctionComponent<IAppProps> = (props) => {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_max_static');

    return (
        <>
            <section className={`river-mini-overview ${css.OverView}`}>
                <article className="grid-content">
                    <div className="view-item view-item-1">
                        <EFPic name={['DELTAMAX_M_1.webp', 'DELTAMAX_M_1.png']} alt={t('second_capacity')} aria-label={t('second_capacity')} />
                        <span className="text">{t('second_capacity')}</span>
                    </div>
                    <div className="view-item view-item-2">
                        <span className="text">{t('AC_Output_value')}</span>
                        <span className="text">{t('AC Output')}</span>
                    </div>
                    <div className="view-item view-item-3">
                        <EFPic name={['DELTAMAX_M_2.webp', 'DELTAMAX_M_2.png']} alt={t('Fast Charging')} aria-label={t('Fast Charging')} />
                        <span className="text">{t('Fast Charging')}</span>
                    </div>
                    <div className="view-item view-item-4">
                        <EFPic name={['DELTAMAX_M_3.webp', 'DELTAMAX_M_3.png']} alt={t('second_solar_power')} aria-label={t('second_solar_power')} />
                        <span className="text">
                            {t('second_solar_power_value')}
                            {t('second_unit')}
                        </span>
                        <span className="text">{t('second_solar_power')}</span>
                    </div>
                    <div className="view-item view-item-5">
                        <EFPic name={['DELTAMAX_M_4.webp', 'DELTAMAX_M_4.png']} alt={t('second_capacity')} aria-label={t('second_capacity')} />
                        <span className="text">{t('second_smart_generator')}</span>
                    </div>
                    <div className="view-item view-item-6">
                        <EFPic name={['DELTAMAX_M_5.webp', 'DELTAMAX_M_5.png']} alt={t('second_capacity')} aria-label={t('second_capacity')} />
                        <span className="text">{t('second_safe_use_bms')}</span>
                    </div>
                    <div className="view-item view-item-7">
                        <EFPic name={['DELTAMAX_M_6.webp', 'DELTAMAX_M_6.png']} alt={t('second_capacity')} aria-label={t('second_capacity')} />
                        <span className="text">{t('second_easy_control_app')}</span>
                    </div>
                </article>
            </section>
        </>
    );
};

export default App;
